<template>
    <div>
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/customer' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item>调查问卷</el-breadcrumb-item>
                        </el-breadcrumb>
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">调查问卷</div>
                        </el-col>

                    </el-row>
                </div>

                <el-table
                        :data="dataList"  v-loading="loading"  style="text-align: center; width: 100%;">
                    <el-table-column prop="questionnaireName" label="问卷名称" >
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.done === 0" @click="toForm(scope.row.id)" type="text">{{scope.row.questionnaireName}}</el-button>
                            <span style="color: grey;" v-else>{{scope.row.questionnaireName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="readState" prop="customerReadState" label="问卷回复查阅状态"  >
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.customerReadState === '01'"  type="danger">未查阅</el-tag>
                            <el-tag v-if="scope.row.customerReadState === '02'"  type="success">已查阅</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" >
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" v-if="scope.row.customerReadState === '01'"  @click="showInfo2(scope.row)">查阅</el-button>
                            <el-button type="text" size="mini"  @click="showInfo(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>
            </el-card>
        </div>

        <questionnaire-answer v-if="showInfoVisible" ref="showinfo" @refreshDataList="searchData"></questionnaire-answer>
    </div>
</template>
<script>
    import {
        Vue,
        Component
    } from 'vue-property-decorator'
    import Template from "../../../template";
    import QuestionnaireAnswer from "./questionnaire-answer.vue"

    @Component({
        name: 'tQuestionnaire',
        components: {
            Template,
            QuestionnaireAnswer
        }
    })
    export default class tQuestionnaire extends Vue {
        currentNo = 1;
        pageSize = 10;
        pageTotal = 0;
        dataList=[]
        loading = false;
        showInfoVisible = false
        readState = false
        created() {
          this.searchData();
        }
        toForm(id) {
            this.$router.push({
                path:'/customer/questionaire/info',
                query:{id:id}
            });
        }
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchData();
        }
        handleCurrentChange(val) {
            this.currentNo = val;
            this.searchData();
        }
        // 多选
        selectionChangeHandle (val) {
            this.dataListSelections = val
        }
        searchData () {
            this.loading = true
            this.$request.get('/bjba/questionnaire/customerFindlist',{page:this.currentNo,pagesize:this.pageSize}).then(res => {
                const {data} = res
                this.loading = false
                this.dataList = data.data.content
                this.pageTotal = data.data.totalElements
                this.dataList.map(item => {
                    if(item.customerReadState) {
                        this.readState = true
                    }
                })
            }).catch(err => {
                this.$message({
                    message: '获取列表出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
            this.loading = false
            console.log(err)
            })
        }
        showInfo(val) {
            this.showInfoVisible = true
            this.$nextTick(() => {
                this.$refs.showinfo.init(val)
            })
        }
        showInfo2(val) {
            console.log("点击查阅传入参数：",val)
            this.showInfoVisible = true
            this.$nextTick(() => {
                this.$refs.showinfo.init(val)
            })
            this.updateCustomerReadState(val.replayId)
        }
        updateCustomerReadState(replayId) {
            this.$request({
                url: `/bjba/questionnaireReplay/updateCustomerReadState/${replayId}`,
                method: 'get',
                params: {
                    customerReadState: '02'
                }
            }).then(response => {
                // console.log("修改问卷回复查阅状态值返回信息：",response)
            }).catch(error => {
                console.log(error)
            });
        }
    }
</script>
<style lang="scss" scoped>
    .bcgl {}
</style>
